import { env } from './env'

function IsEnvironmentFeaturesEnabled(featureName: string): boolean {
  return (env.VITE_ENABLE_ENV_FEATURES || '').split(',').includes(featureName)
}

export const EnvironmentFeaturesEnabled = {
  claimCallMenuAttendableCsi: IsEnvironmentFeaturesEnabled('claimcallmenuattendablecsi'),
  claimCallMenuAttendableEob: IsEnvironmentFeaturesEnabled('claimcallmenuattendableeob'),
  claimCallMenuAttendableDirectLine: IsEnvironmentFeaturesEnabled('claimcallmenuattendabledirectline'),
  claimCallMenuAttendableWorkersComp: IsEnvironmentFeaturesEnabled('claimcallmenuattendableworkerscomp'),
}
